module.exports = __webpack_public_path__ + "img/rotate_90_degrees_ccw.6500faf5.svg";